import { createPortal } from 'react-dom';

interface TableHeaderControlsProps {
  /**
   * The page-header slot element (from a `ref` callback) the controls should
   * render into. While null (first render, or a page that doesn't provide a
   * slot) the controls render inline where the component is declared — the
   * table's actions row — so the table stays fully usable without a slot.
   */
  container?: HTMLElement | null;
  children: React.ReactNode;
}

/**
 * Renders the table's Filters / Columns buttons into the page title row
 * (2026-07-14, user request): pages place a slot `<div ref={...}>` in their
 * header right-side button group and pass the element down as `container`;
 * the table's controls then portal into it, keeping all table state (column
 * visibility, filters-open) inside the DataTable component.
 */
export function TableHeaderControls({ container, children }: TableHeaderControlsProps) {
  if (container) return createPortal(children, container);
  return <>{children}</>;
}
